import styled from '@emotion/styled';

import SubmitButtonBase from '../../SubmitButtonBase';

const StyledSubmitButton = styled(SubmitButtonBase)({
  marginBottom: 16
});

export default StyledSubmitButton;
